import { emitApiTelemetry, emitNetworkError, perfNow, sanitisePath } from "../../telemetry/apiTelemetry";

/** Cheapest authenticated Graph call; the body is discarded, only reachability matters. */
const GRAPH_PROBE_URL = "https://graph.microsoft.com/v1.0/me?$select=id";

/**
 * Probes Microsoft 365 reachability for the status dot. Probed from the client
 * because the backend cannot know whether *this* user's Graph access works —
 * revoked consent or a conditional-access block leave the service healthy.
 *
 * Deliberately does not refresh on a 401: this is a background poll, and a
 * refreshing poll would pop the silent-refresh dialog every cycle (AIVA-5861). A
 * stale token reads as unreachable until the next real action refreshes it.
 *
 * Any non-OK counts as unreachable, and it never throws — a failure is the answer.
 */
export async function probeM365Reachability(token: string): Promise<boolean> {
  const templatedPath = sanitisePath(GRAPH_PROBE_URL);
  const started = perfNow();
  try {
    const response = await fetch(GRAPH_PROBE_URL, {
      headers: { Authorization: `Bearer ${token}` },
    });
    emitApiTelemetry(templatedPath, "GET", started, response.status, "integration");
    return response.ok;
  } catch (err) {
    emitNetworkError(templatedPath, "GET", started, "integration", err);
    return false;
  }
}
